// removed by extract-text-webpack-plugin
module.exports = {"FormLarge":"_3ZSJR","CustomInput":"_3UNLc","Label":"_FDuME","Bar":"_3wRU_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PassportDetails/PassportDetails.scss
// module id = 475
// module chunks = 0